module.exports = __webpack_public_path__ + "img/course-time.e9f12a6a.png";